var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h3", { staticStyle: { "margin-top": "0px" } }, [
      _vm._v("\n    Device Health\n  "),
    ]),
    _vm._v(" "),
    _c("div", { attrs: { "data-v-6e458483": "" } }, [
      _c("div", { staticClass: "diagnostic-health-popover" }, [
        _c("div", { staticClass: "grid gap-h_s" }, [
          _c("div", { staticClass: "span-12" }, [
            _c("div", { staticClass: "flex justify-between" }, [
              _c("label", [_vm._v("Battery Status")]),
              _vm._v(" "),
              _vm.battery.batteryPercentage != null
                ? _c("div", [
                    _c("span", [
                      _vm._v(_vm._s(_vm.battery.batteryPercentage) + " %"),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.battery.batteryPercentage == null
                ? _c("div", [_c("span", [_vm._v("N/A")])])
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _vm.battery.batteryVoltage
            ? _c("div", { staticClass: "span-12" }, [
                _c("div", { staticClass: "flex justify-between" }, [
                  _c("label", [_vm._v("Vehicle Battery Voltage")]),
                  _vm._v(" "),
                  _c("div", [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.round(_vm.battery.batteryVoltage)) + " V"
                      ),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "span-12" }, [
            _c("div", { staticClass: "flex justify-between" }, [
              _c("label", [_vm._v("Temperature F/C")]),
              _vm._v(" "),
              _vm.battery.currentTemperature
                ? _c("div", [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.currentTemperature.fahrenheit) +
                          " F (" +
                          _vm._s(_vm.currentTemperature.celsius) +
                          " C)"
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.battery.currentTemperature
                ? _c("div", [_c("span", [_vm._v("N/A")])])
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _vm.battery.chargingState
            ? _c("div", { staticClass: "span-12" }, [
                _c("div", { staticClass: "flex justify-between" }, [
                  _c("label", [_vm._v("Charging State")]),
                  _vm._v(" "),
                  _c("div", [
                    _c("span", [_vm._v(_vm._s(_vm.battery.chargingState))]),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.battery.chargerType
            ? _c("div", { staticClass: "span-12" }, [
                _c("div", { staticClass: "flex justify-between" }, [
                  _c("label", [_vm._v("Charger Type")]),
                  _c("div", [
                    _c(
                      "span",
                      { staticClass: "diagnostic-field-value indicator-good" },
                      [_vm._v(_vm._s(_vm.battery.chargerType))]
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "span-12" }, [
            _c("div", { staticClass: "flex justify-between" }, [
              _c("label", [_vm._v("Motion State")]),
              _c("div", [
                _c("span", [_vm._v(_vm._s(_vm.battery.currentMotionState))]),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "flex justify-center",
            staticStyle: { "margin-top": "20px" },
          },
          [
            _c("span", { staticClass: "report-timestamp" }, [
              _vm._v(_vm._s(_vm.timestamp)),
            ]),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }